import { BehaviorSubject } from "rxjs";
import { AppConfigService } from '@app/core/services/app-config-service';
import * as i0 from "@angular/core";
export class LoaderService {
    constructor() {
        this.isLoaderShown = new BehaviorSubject([false, false]);
    }
    showLoader(coverHeader = false) {
        if (!AppConfigService.config.App.ShowLoader) {
            return;
        }
        this.isLoaderShown.next([true, coverHeader]);
    }
    hideLoader() {
        this.isLoaderShown.next([false, false]);
    }
}
LoaderService.ngInjectableDef = i0.defineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(); }, token: LoaderService, providedIn: "root" });
